export enum RecommendationType {
  PERSON = 'person',
  ARTICLE = 'article',
  HELP = 'help'
}